/* tslint:disable: member-ordering forin */
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { forbiddenNameValidator } from "../shared/forbidden-name.directive";
import { AlertService, UserService } from "../_services/index";
import { Country, States, Cities } from "../_models/index";
import { Router } from "@angular/router";
import { CognitoService } from "../_services/Cognito.service";
import { GetuserService } from "../_services/getuser.service";
import * as AWS from 'aws-sdk';
import { NotificationsService } from "angular2-notifications";

@Component({
  selector: "app-signup",
  templateUrl: "./signup.component.html",
  styleUrls: ["./signup.component.css"],
  providers: [UserService],
})
export class SignupComponent implements OnInit {
  @ViewChild("imagex") imagex: any;
  userAttributes: any;
  logoimage: any;
  countries: Country[] = [];
  model: any = {};
  isemailAvailable = false;
  isUsernameAvailable = false;
  loading = false;
  heroForm: FormGroup;
  passMatch: Boolean;
  states: States[] = [];
  cities: Cities[] = [];
  isstateloaded = false;
  iscityloaded = false;
  passwordSpecialMatch: boolean;
  isImageValid: boolean = true;
  isSellerTrue: boolean = true;
  isSellerCondition: boolean = false;
  passwordConfirmed: boolean;
  minLoader: any;
  lat;
  lng;
  isBuyerTrue: boolean = true;
  isBuyerCondition: boolean = false;
  isConfirmSignUp: boolean = false;
  cityName: string;
  stateName: string;
  countryName: string;
  confirmationCode: string;
  showResendButton: boolean;
  timeRemaining = '15:00'; // 15
  public options = {
    position: ["top", "right"],
    lastOnBottom: false,
    preventDuplicates: true,
    timeout : 1000,
    showProgressBar: true
  }
  constructor(
    private router: Router,
    private userService: UserService,
    private alertService: AlertService,
    private cognitoService: CognitoService,
    private getUserService:GetuserService,
    private _service: NotificationsService,
  ) { }

  ngOnInit(): void {
    this.isConfirmSignUp = this.getUserService.isConfirmSignup;
    this.getlocation();
    this.minLoader = "../../assets/images/smallLoader.gif";
    this.model.country_id = 1;
    this.model.is_seller = true;
    this.heroForm = new FormGroup({
      first_name: new FormControl("", [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        forbiddenNameValidator(/bob/i), // <-- Here's how you pass in the custom validator.
      ]),
      last_name: new FormControl("", [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        forbiddenNameValidator(/tob/i), // <-- Here's how you pass in the custom validator.
      ]),
      username: new FormControl("", [
        Validators.required,
        Validators.minLength(2),
        Validators.maxLength(30),
        forbiddenNameValidator(/tob/i), // <-- Here's how you pass in the custom validator.
      ]),
      email: new FormControl("", [
        Validators.required,
        Validators.email,
        forbiddenNameValidator(/tob/i), // <-- Here's how you pass in the custom validator.
      ]),
      password: new FormControl("", [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(20),
        forbiddenNameValidator(/tob/i), // <-- Here's how you pass in the custom validator.
      ]),
      address: new FormControl("", Validators.required),
      zip_code: new FormControl("", Validators.required),
      state_id: new FormControl("", Validators.required),
      country_id: new FormControl("", Validators.required),
      city_id: new FormControl("", Validators.required),
      alterEgo: new FormControl(),
      lat: new FormControl(),
      lng: new FormControl(),
      power: new FormControl("", Validators.required),
      terms_conditions: new FormControl("", Validators.required),
    });

    this.logoimage = "../../assets/images/logomain.png";
    this.userService.getAllCountry().subscribe(
      (data) => {
        this.countries = data;
        this.loading = false;
      },
      (error) => {
        this.alertService.error(error);
        this.loading = false;
      }
    );
    this.startTimer();
  }

  startTimer() {
    let timer = 15 * 60; // 15 minutes
    let interval = setInterval(() => {
      timer--;
      this.timeRemaining = this.formatTime(timer);
      if (timer <= 0) {
        this.showResendButton = true;
        clearInterval(interval);
      }
    }, 1000); // 1 second
  }

  formatTime(seconds: number) {
    let minutes = Math.floor(seconds / 60);
    let secondsRemaining = seconds % 60;
    return `${minutes}:${secondsRemaining.toString().padStart(2, '0')}`;
  }

  onKeyCheckUsername(event: any) {
    // without type info
    const username = event.target.value;
    if (username !== "") {
      this.userService.getUserByUsername(username).subscribe(
        (data) => {
          if (data.status === 200) {
            this.isUsernameAvailable = false;
          }

          if (data.status === 400) {
            this.isUsernameAvailable = true;
          }
        },
        (error) => {
          this.alertService.error(error);
          this.loading = false;
        }
      );
    }
  }

  onKeyCheckEmail(event: any) {
    // without type info
    const email = event.target.value;
    if (email !== "") {
      this.userService.getUserByEmail(email).subscribe(
        (data) => {
          if (data.status === 200) {
            this.isemailAvailable = false;
          }
          if (data.status === 400) {
            this.isemailAvailable = true;
          }
        },
        (error) => {
          // this.alertService.error(error);
          this.loading = false;
        }
      );
    } else {
      this.isemailAvailable = false;
    }
  }

  onKeyCheckpasswordConfirm(event: any) {
    // without type
    if (event.target.value != undefined && event.target.value.length >= 8) {
      if (this.model.password === event.target.value) {
        this.passMatch = false;
      } else {
        this.passMatch = true;
      }
    } else {
      this.passMatch = false;
    }
  }

  handleFileSelect($event): void {
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    const file: File = inputValue.files[0];
    if (file.type === "image/png" || file.type === "image/jpeg") {
      this.isImageValid = true;
      const myReader: FileReader = new FileReader();

      myReader.onloadend = (e) => {
        this.model.image = myReader.result;
      };
      myReader.readAsDataURL(file);
    } else {
      this.imagex.nativeElement.value = "";
      this.isImageValid = false;
    }
  }

  public onChangeCountry(country_id): void {
    // event will give you full brief of action
    this.model.country_id = country_id;
    for (let i = 0; i < this.countries.length; i++) {
      const country = this.countries[i];
      if (this.model.country_id == country.id) {
        this.countryName = country.name;
      }
    }
    this.isstateloaded = true;
    this.userService.getAllStates(country_id).subscribe(
      (data) => {
        this.states = data;
        this.isstateloaded = false;
      },
      (error) => {
        this.alertService.error(error);
        this.loading = false;
      }
    );
  }

  public onChangeState(state_id): void {
    // event will give you full breif of action
    this.iscityloaded = true;
    this.model.state_id = state_id;
    for (let i = 0; i < this.states.length; i++) {
      const state = this.states[i];
      if (this.model.state_id == state.id) {
        this.stateName = state.name;
      }
    }
    this.userService.getAllCities(state_id).subscribe(
      (data) => {
        this.cities = data;
        this.iscityloaded = false;
      },
      (error) => {
        this.alertService.error(error);
        this.loading = false;
      }
    );
  }

  public onChangeCity(city_id): void {
    this.model.city_id = city_id;
    for (let i = 0; i < this.cities.length; i++) {
      const city = this.cities[i];
      if (this.model.city_id == city.id) {
        this.cityName = city.name;
      }
    }
  }

  public onChangeSeller(is_seller): void {
    this.isSellerTrue = !is_seller ? true : false;
    this.isSellerCondition = is_seller;
  }

  public onChangeBuyer(is_buyer): void {
    this.isBuyerTrue = !is_buyer ? true : false;
    this.isBuyerCondition = is_buyer;
  }

  public onChangeTerms(is_terms): void {
    const isSellerTrue = this.isSellerTrue;
    this.isSellerCondition = !is_terms ? true : false;
  }

  passwordValueValidator(control) {
    if (control.value != undefined && control.value.length >= 8) {
      // if (control.value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,100})/)) {
      if (
        control.value.match(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
        )
      ) {
        this.passwordSpecialMatch = false;
      } else {
        this.passwordSpecialMatch = true;
      }
    } else {
      this.passwordSpecialMatch = false;
    }
  }

  register() {
    this.loading = true;
    this.model.lat = this.lat;
    this.model.lng = this.lng;
    this.userService.create(this.model).subscribe(
      (data) => {
        if (data.status == 200) {
          if (
            (this.model.is_seller == true || this.model.is_buyer == true) &&
            data.redirect_to_stripe == 1 &&
            data.account_already == 0
          ) {
            this.alertService.success("Registration successful", true);
            // window.location.href =
            //   "https://dashboard.stripe.com/oauth/authorize?response_type=code&client_id=ca_EhG8I0NY8m90bn6cdKPnOJGR7L5VTvQ1&scope=read_write&state=" +
            //   data.result.id;
          } else if (
            (this.model.is_seller == true || this.model.is_buyer == true) &&
            data.redirect_to_stripe == 0 &&
            data.account_already == 1
          ) {
            this.alertService.success(
              "User registered successfully. We sent a link to your registered email to connect your stripe account with BidJones to receive payments.",
              true
            );
          } else {
            this.alertService.success("Registration successful", true);
            // this.router.navigate(["/confirm-signUp"]);
          }
        } else {
          this.alertService.error(data.message);
        }
      },
      (error) => {
        this.alertService.error(error);
        this.loading = false;
      }
    );
  }

  /**
   * function to get the geolocation
   */
  public getlocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
      });
    }
  }

  SignUp(): void {
    let $this = this;
    this.getUserService.model = this.model;
    this.getUserService.cityName = this.cityName;
    this.getUserService.stateName = this.stateName;
    this.getUserService.countryName = this.countryName;
    this.cognitoService.signUp(this.model, this.cityName, this.stateName, this.countryName)
      .then((reponse) => {
        this.loading = true;
        $this.register();
        this.isConfirmSignUp = true;
        this.loading = false;

      })
      .catch((error) => {
        this.loading = false;
       
      });
  }

  confirmSignUp(confirmationCode: string): void {
    let email = this.model.email || this.getUserService.username;
    if(confirmationCode){
      confirmationCode = confirmationCode.replace(/\s/g, '');
      this.cognitoService.confirmSignUp(email, confirmationCode)
        .then((reponse) => {
          if(this.getUserService.isForgetScreen){
            this._service.success("User verified successfully. Proceed to reset password.");
            this.router.navigate(['/forget-password']);
          }
          else{
            this.router.navigate(['/login']);
          }
         
        })
        .catch((error) => {
        });
    }
    }

    resendConfirmationCode(){
      let email = this.model.email || this.getUserService.username;
      this.cognitoService.resendOtp(email)
        .then((reponse) => {
          this.showResendButton = false;
        })
        .catch((error) => {
         
        });
    }

    
}



// WEBPACK FOOTER //
// ./src/app/signup/signup.component.ts